import React from 'react';
import { IQuestionItem, IQuestionType } from 'pages/formsCreate/types';
import { useStyles } from './styles';
import { QuestionCard } from './QuestionCard';

interface IProps {
  data: IQuestionItem<IQuestionType>[];
  disableInput?: boolean;
}

export const QuestionnaireContainer = ({ data, disableInput }: IProps) => {
  const { questionContainer } = useStyles();
  return (
    <div className={questionContainer}>
      {data.map((question: IQuestionItem<IQuestionType>) => (
        <QuestionCard data={question} key={question.id} disableInput={disableInput} />
      ))}
    </div>
  );
};
